/**
 * Small shared bits of theme data. Keep this tiny: every theme should read as
 * its own place, so most values live in the pack itself.
 */

/** Soft white cumulus used by most skies. */
export const CLOUD_WHITE = '#ffffff';

/** Festival colours for balloons, bunting and confetti. */
export const FESTIVE = ['#ff6b6b', '#ffd43b', '#4dabf7', '#69db7c', '#f783ac', '#9775fa'];

/** Parrot plumage (scarlet, sunflower, sky blue, leaf green). */
export const PARROTS = ['#ff4d4d', '#ffd43b', '#339af0', '#51cf66'];

/** Warm wood for trunks. */
export const TRUNK = '#8b5a3c';
